<template>
  <div class="opening-hours-schedule text-left">
    <v-row no-gutters>
      <v-col class="col-md-12 margin-bottom-out">
        <label class="form-checkbox">
          <input data-cy="opens-on-saturday" type="checkbox" v-model="opensOnSaturdays" /><i class="form-icon"></i>
          {{ $t('honda.repair.repairshop.open-sat') }}
        </label>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="col-md-12">
        <label class="label" style="font-size: 13px" for="morning-hours">{{
          $t('honda.repair.repairshop.week-morn')
        }}</label>
        <opening-hours id="morning-hours" v-model="morningHours" />
      </v-col>

      <v-col class="col-md-12">
        <label class="label" for="afternoon-hours">{{ $t('honda.repair.repairshop.week-even') }}</label>
        <opening-hours id="afternoon-hours" v-model="afternoonHours" :min-open="morningClose" />
      </v-col>

      <v-col class="col-md-12">
        <label class="label" for="saturday-hours">{{ $t('honda.repair.repairshop.saturday') }}</label>
        <opening-hours id="saturday-hours" v-model="saturdayHours" :disabled="!opensOnSaturdays" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OpeningHours from '@/components/repairshop/OpeningHours'
import {toUiRange} from '@/utils/opening-hours'

const MO_FR = 'Mo-Fr '
const SA = 'Sa '

export default {
  name: 'OpeningHoursSchedule',
  components: {OpeningHours},
  props: {
    value: Array,
  },
  data: () => ({
    opensOnSaturdays: false,
    morningHours: null,
    afternoonHours: null,
    saturdayHours: null,
  }),
  computed: {
    morningClose() {
      const parts = (this.morningHours || '').split(' - ')
      return parts[1] || ''
    },
  },
  created() {
    const entries = this.value || []
    const moFrSlots = entries.filter(s => s.startsWith(MO_FR)).map(s => s.slice(MO_FR.length))
    const saSlot = entries.find(s => s.startsWith(SA))

    if (moFrSlots[0]) this.morningHours = toUiRange(moFrSlots[0])
    if (moFrSlots[1]) this.afternoonHours = toUiRange(moFrSlots[1])

    this.opensOnSaturdays = !!saSlot
    if (saSlot) this.saturdayHours = toUiRange(saSlot.slice(SA.length))
  },
  methods: {
    sch() {
      return [
        this.morningHours && `${MO_FR}${this.morningHours.replace(/ /g, '')}`,
        this.afternoonHours && `${MO_FR}${this.afternoonHours.replace(/ /g, '')}`,
        this.opensOnSaturdays && this.saturdayHours && `${SA}${this.saturdayHours.replace(/ /g, '')}`,
      ].filter(Boolean)
    },
  },
  watch: {
    morningHours: function (val) {
      this.$emit('input', this.sch())
    },
    afternoonHours: function (val) {
      this.$emit('input', this.sch())
    },
    saturdayHours: function (val) {
      this.$emit('input', this.sch())
    },
    opensOnSaturdays: function (val) {
      if (!this.saturdayHours) {
        this.saturdayHours = this.morningHours
      }
      this.$emit('input', this.sch())
    },
  },
}
</script>

<style scoped>
.label {
  font-family: 'ProximaNovaExCnLight', 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-size: 14px;
  color: #888;
  letter-spacing: 1px;
  background: white;
  font-weight: bold;
}
.bold-900 {
  font-size: 26px;
}
.form-select {
  font-family: 'Roboto', sans-serif;
  color: #888;
}
</style>
